var map = {
	"./arachides.svg": "33ae",
	"./celeri.svg": "1d2a",
	"./crustaces.svg": "85fa",
	"./fruits-a-coque.svg": "8859",
	"./gluten.svg": "61ad",
	"./lait.svg": "73fe",
	"./lupin.svg": "a2a7",
	"./mollusques.svg": "af39",
	"./moutarde.svg": "2514",
	"./oeuf.svg": "b866",
	"./poisson.svg": "1d65",
	"./sesame.svg": "746c",
	"./soja.svg": "39ef",
	"./sulfite.svg": "b173"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2412";